const getisLoggedIn = () => {
  // Verifică în toate spațiile de stocare pentru a vedea dacă utilizatorul este logat
  let isLoggedIn = sessionStorage.getItem('isLoggedIn') || localStorage.getItem('isLoggedIn') || getCookie('_isLoggedInCjpc');
  return isLoggedIn === 'true';
};

const getCookie = (name) => {
  // Funcția getCookie
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};
const deleteCookie = (name) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
};

let alreadyChecked = false;
let lastCheckTime = 0;
const CHECK_INTERVAL = 60000; // Verifică token-ul doar o dată la 60 secunde
let retryCount = 0;
const MAX_RETRIES = 2;

// Funcție helper pentru a reseta retry count-ul (apelează-o când știi sigur că conexiunea e OK)
export const resetTokenRetries = () => {
  retryCount = 0;
  lastCheckTime = 0;
};

const verificareToken = () => {
  // Verifică dacă utilizatorul este logat
  if (!getisLoggedIn()) {
    return { token: null, ok2goval: null };
  }

  // Verifică token-ul în toate spațiile de stocare
  let token = sessionStorage.getItem('token') || localStorage.getItem('token') || getCookie('_tokenCjpc');
  let ok2goval = sessionStorage.getItem('ok2go') || localStorage.getItem('ok2go') || getCookie('ok2go');

  if (!token) {
    return { token: null, ok2goval: null };
  }

  if (ok2goval === 'false') {
    if (window.location.pathname === '/logout') {
      // Dacă utilizatorul este pe /logout și ok2go este false, ștergem tot ce este legat de ok2go
      localStorage.removeItem('ok2go');
      sessionStorage.removeItem('ok2go');
      deleteCookie('ok2go');  
    } else if (window.location.pathname !== '/licentiere') {
      // Dacă nu suntem pe /licentiere și ok2go este false, redirecționăm la /licentiere
      window.location.href = '/licentiere';
      return { token, ok2goval };  
    }
  }
  
   // ✅ Fă un singur fetch dacă tokenul este prezent și validabil
   // Verifică doar dacă a trecut suficient timp de la ultima verificare
   const currentTime = Date.now();
   const shouldCheck = currentTime - lastCheckTime > CHECK_INTERVAL;
   
   if (token && ok2goval === 'true' && !alreadyChecked && shouldCheck) {
    alreadyChecked = true;
    lastCheckTime = currentTime;

    // Timeout pentru fetch - 10 secunde maxim
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    fetch(`${window.API_URL}user`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      signal: controller.signal
    })
      .then((res) => res.json().then((body) => ({ status: res.status, body })))
      .then(({ status, body }) => {
        clearTimeout(timeoutId);
        alreadyChecked = false;
        retryCount = 0; // Reset retry count pe succes
        
        if (status === 401 || body?.message === 'Utilizatorul nu este logat!') {
          console.warn('🔒 Token invalid. Se face redirect...');
          sessionStorage.removeItem('token');
          localStorage.removeItem('token');
          deleteCookie('_tokenCjpc');
          window.location.href = '/logout';
        }
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        alreadyChecked = false;
        
        // Dacă e timeout sau eroare de rețea, încearcă din nou
        if (err.name === 'AbortError') {
          console.warn('⏱️ Timeout la validarea tokenului. Se încearcă din nou...');
          retryCount++;
          
          if (retryCount < MAX_RETRIES) {
            // Resetează timpul pentru a permite o nouă verificare
            lastCheckTime = 0;
            return;
          }
        }
        
        // Doar după MAX_RETRIES eșuări consecutive, deconectează
        if (retryCount >= MAX_RETRIES) {
          console.error('💥 Eroare repetată la validarea tokenului:', err);
          window.location.href = '/logout';
        } else {
          console.warn('⚠️ Eroare temporară la validarea tokenului, se ignoră:', err);
          retryCount++;
          lastCheckTime = 0; // Permite o nouă verificare
        }
      });
  }

  return { token, ok2goval };
};

export default verificareToken;
